import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { FIELD_CATEGORIES } from "@/data/fieldServices";
import { money } from "@/lib/api";

export const priceLabel = (s) => (s.base_price != null ? `Starting at ${money(s.base_price)}` : "Request a Quote");
export const requestLink = (s) => (s.kind === "quote" ? `/request-inspection?service=${s.id}` : `/property-inspections/book?service=${s.id}`);

export const FieldServiceCard = ({ s }) => {
  const Icon = Icons[FIELD_CATEGORIES.find((c) => c.id === s.category)?.icon] || Icons.ClipboardList;
  return (
    <article data-testid={`fs-card-${s.id}`} className="group flex flex-col rounded-2xl border border-slate-200 bg-white p-6 transition-[box-shadow,transform] duration-300 hover:-translate-y-1 hover:shadow-[0_18px_40px_-22px_rgba(11,19,43,0.35)]">
      <div className="flex items-start justify-between gap-3">
        <div className="rounded-xl bg-gold/10 p-3"><Icon className="h-5 w-5 text-gold" /></div>
        <span data-testid={`fs-price-${s.id}`} className={`rounded-full px-3 py-1 text-xs font-semibold ${s.base_price != null ? "bg-[#0B132B] text-white" : "bg-[#F5F3EC] text-slate-600"}`}>{priceLabel(s)}</span>
      </div>
      <h3 className="mt-5 font-display text-lg font-bold text-[#0B132B]">{s.name}</h3>
      <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-500">{s.description}</p>
      <div className="mt-6 flex gap-2">
        <Link to={`/field-services/service/${s.id}`} data-testid={`fs-learn-${s.id}`} className="flex-1 rounded-full border border-slate-300 py-2.5 text-center text-sm font-semibold text-[#0B132B] transition-colors hover:border-gold">Learn More</Link>
        <Link to={requestLink(s)} data-testid={`fs-request-${s.id}`} className="flex-1 rounded-full bg-gold py-2.5 text-center text-sm font-semibold text-[#0B132B] transition-colors hover:bg-[#E5C158]">Request Service</Link>
      </div>
    </article>
  );
};

export const CategoryTile = ({ c }) => {
  const Icon = Icons[c.icon];
  return (
    <Link to={`/field-services/${c.id}`} data-testid={`fs-cat-${c.id}`} className="group relative overflow-hidden rounded-2xl">
      <img src={c.image} alt={c.name} loading="lazy" className="h-56 w-full object-cover transition-transform duration-500 group-hover:scale-105" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0B132B]/90 via-[#0B132B]/40 to-transparent" />
      <div className="absolute bottom-0 p-5 text-white">
        <Icon className="h-5 w-5 text-gold" />
        <h3 className="mt-2 font-display text-lg font-bold">{c.name}</h3>
        <p className="mt-1 text-xs text-slate-200">{c.short}</p>
      </div>
    </Link>
  );
};
